import { z } from 'zod';

export const MaterialAttachment = z.object({
  id: z.number(),
  file: z.string(),
  file_url: z.string().nullable(),
  original_filename: z.string(),
  created_at: z.string(),
});

export type MaterialAttachment = z.infer<typeof MaterialAttachment>;

export const MIN_MATERIAL_SHEET_DIMENSION_MM = 25;

export const MaterialSheetSizeItem = z.object({
  x: z.number().min(MIN_MATERIAL_SHEET_DIMENSION_MM),
  y: z.number().min(MIN_MATERIAL_SHEET_DIMENSION_MM),
  z: z.number().min(MIN_MATERIAL_SHEET_DIMENSION_MM),
});
export type MaterialSheetSizeItem = z.infer<typeof MaterialSheetSizeItem>;

export const Material = z.object({
  id: z.number(),
  name: z.string(),
  attachments: z.array(MaterialAttachment).optional(),
  material_price: z.string(), // DecimalField from backend comes as string
  price_updated_at: z.iso.datetime(), // Timestamp when price was last updated
  material_price_type: z.enum(['area', 'volume', 'volume_l']),
  sheet_sizes: z.array(MaterialSheetSizeItem).nullable(),
  use_sheet_size: z.boolean(),
  density_kilogram_per_m3: z.string().nullable(), // DecimalField from backend comes as string
  surface_hardness: z.number().int().positive().nullable().optional(),
  composite_time_multiplier: z.string().nullable().optional(),
  finishing_time_multiplier: z.string().nullable().optional(),
  cnc_time_multiplier: z.string().nullable().optional(),
  cured_thickness_mm: z.string().nullable().optional(), // DecimalField from backend comes as string
  is_archived: z.boolean(),
  // DFM Checks
  count_holes: z.boolean(),
  unmachinable_holes: z.boolean(),
  drill_head_radius_mm: z.string(), // DecimalField from backend comes as string
  drill_bit_length_to_diameter_ratio_blind: z.string(), // DecimalField from backend comes as string
  drill_bit_length_to_diameter_ratio_through: z.string(), // DecimalField from backend comes as string
  thin_walls: z.boolean(),
  min_thickness_mm: z.string(), // DecimalField from backend comes as string
  max_thickness_mm: z.string(), // DecimalField from backend comes as string
  narrow_gaps: z.boolean(),
  angle_tolerance_degrees: z.string(), // DecimalField from backend comes as string
  internal_volume: z.boolean(),
  blocking_up: z.boolean(),
  description: z.string(),
});

export type Material = z.infer<typeof Material>;
